// src/pages/Privacy.js
import React from "react";
import "../App.css";

const Privacy = () => {
  return (
    <section className="legal-page">
      <header className="legal-hero">
        <h1 className="legal-hero-title">Privacy Policy</h1>
        <p className="legal-hero-subtitle">
          How Ndils Daily Care collects, uses and protects your personal data.
        </p>
        <p className="legal-meta">
          Last updated: November 2025 • In line with UK GDPR principles
        </p>
      </header>

      <div className="legal-content">
        <section className="legal-section">
          <h2>1. Who We Are</h2>
          <p>
            Ndils Daily Care is a care provider offering support to vulnerable
            adults in the community. We are committed to protecting the privacy
            and confidentiality of everyone we work with.
          </p>
        </section>

        <section className="legal-section">
          <h2>2. Information We Collect</h2>
          <p>We may collect the following types of information:</p>
          <ul className="legal-list">
            <li>Contact details such as name, phone number and email address.</li>
            <li>
              Care-related information you choose to share in enquiry forms.
            </li>
            <li>Technical data such as IP address and basic analytics.</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>3. How We Use Your Information</h2>
          <p>We use your information to:</p>
          <ul className="legal-list">
            <li>Respond to enquiries and provide care-related information.</li>
            <li>Arrange assessments and follow-up communication.</li>
            <li>Improve our website, services and user experience.</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>4. Legal Basis for Processing</h2>
          <p>
            We process personal data based on your consent, our legitimate
            interests in providing care services, and in some cases to meet
            legal or regulatory obligations.
          </p>
        </section>

        <section className="legal-section">
          <h2>5. Data Sharing</h2>
          <p>
            We do not sell your data. We may share limited information with
            trusted partners (for example healthcare professionals or regulators)
            where necessary and lawful.
          </p>
        </section>

        <section className="legal-section">
          <h2>6. Data Retention</h2>
          <p>
            We keep your personal data only for as long as needed to fulfil the
            purposes described in this policy, or as required by law or
            regulatory bodies.
          </p>
        </section>

        <section className="legal-section">
          <h2>7. Your Rights</h2>
          <p>You may have the right to:</p>
          <ul className="legal-list">
            <li>Request access to the personal data we hold about you.</li>
            <li>Ask for corrections to inaccurate or incomplete data.</li>
            <li>Request deletion in certain circumstances.</li>
            <li>Withdraw consent where processing is based on consent.</li>
          </ul>
          <p>
            To exercise your rights, please contact us using the details on our
            Contact page.
          </p>
        </section>

        <section className="legal-section">
          <h2>8. Updates to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. Changes will be
            published on this page with an updated “Last updated” date.
          </p>
        </section>
      </div>
    </section>
  );
};

export default Privacy;
